<template>
  <div class="registered">
    <mt-header :title="initData.title">
        <span slot="left" @click="()=>this.$router.back()">
          <i class="iconfont icon-left"></i>
          Return
        </span>
      </mt-header>
    <div class="login_content">
      <div class="login_img">
        <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/footer_home/footerLogo.png" alt=""/>
      </div>
      <div class="email_login">
        <el-form :model="form" :rules="rules" ref="form" class="demo-ruleForm" label-width="50px">
          <el-form-item label="" prop="email">
            <el-input class="inoput_underline" v-model="form.email" placeholder="Email" :disabled='$route.params.id*1 !== 2'></el-input>
            <img class="login_icon" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/login/email.png" alt=""/>
          </el-form-item>
          <el-form-item label="" prop="code">
            <el-input  class="input_Code inoput_underline" v-model="form.code" placeholder="Input the verification code"></el-input>
            <el-button class="btn_Code" type="primary" @click="sendCode" :disabled="disabled">{{countdown}}</el-button>
          </el-form-item>
          <el-form-item label="" prop="name">
            <el-input class="inoput_underline" v-model="form.name" placeholder="Input your name"></el-input>
            <img class="login_icon" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/login/name.png" alt=""/>
          </el-form-item>
          <el-form-item label="" prop="corpname">
            <el-input class="inoput_underline" v-model="form.corpname" placeholder="Input company name"></el-input>
            <img class="login_icon" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/login/corpname.png" alt=""/>
          </el-form-item>
          <el-form-item label="" prop="country">
            <el-select class="inoput_underline" v-model="form.country" placeholder="Select country">
              <el-option v-for="(item,i) in country" :key="i" :label="item[2]" :value="item[2]"></el-option>
            </el-select>
            <img class="login_icon" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/login/country.png" alt=""/>
          </el-form-item>
          <el-form-item label="" prop="pass">
            <el-input class="inoput_underline" v-model="form.mobile" placeholder="Input mobile number"></el-input>
            <img class="login_icon" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/login/duties.png" alt=""/>
          </el-form-item>
          <el-form-item label="" prop="pwd" v-if="$route.params.id*1 !== 1" :rules="[{required: true, message: 'Input password', trigger: 'blur'}]">
            <el-input class="inoput_underline" type="password" v-model="form.pwd" autocomplete="off" placeholder="Input password" show-password></el-input>
            <img class="login_icon" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/login/password.png" alt=""/>
          </el-form-item>
          <el-form-item class="login_button">
            <el-button type="primary" @click="submitForm('form')">{{initData.btn}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>  
  </div>
</template>

<script>
import { tdist_country } from "../../mock/country";
import { reqRegEn, reqRetrieveCode, reqLoginEmail } from "../../api";
import { Toast,Header } from 'mint-ui';
export default {
  components:{
    'mt-header':Header
  },
  props:['initData','formObj'],
  data(){
    var validateEmail = (rule, value, callback)=>{
      if (value === '') {
        this.disabled = true
        callback(new Error('The mailbox address cannot be empty'));
      } else if(!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)){
        this.disabled = true
        callback(new Error('Input email address'));
      } else {
        this.disabled = false
        // console.log(this.disabled);
        callback();
      }
    }
    return{
      rules:{
        email:[
           { validator: validateEmail, trigger: 'change' }
          ],
        name:[
          { required: true, message: 'Input your name', trigger: 'blur' },],
        corpname:[
          { required: true, message: 'Input company name', trigger: 'blur' }],
        country:[
          { required: true, message: 'Select country', trigger: 'change' }],
      },
      form:{
        email:'',
        name: "",
        corpname: "",
        country: "",
        duties: "",
        mobile: '',
        tel: "",
        pwd: "",
        code:'',
      },
      country:[],
      disabled:true,//发送验证码
      countdown:'verification code',//倒计时
    }
  },
  mounted(){
    this.country = tdist_country
    this.init()
  },
  methods:{
    init(){//注册修改显示切换
      if(this.$route.params.id*1==1){
        this.form = this.formObj
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.$route.params.id*1==1){
            this.$emit('submit',this.form)
          }else{
            this.submit()
          }
        } else {
          return false;
        }
      });
    },
    async submit(){
      const response =await reqRegEn(this.form)
      if (response.code*1==2) {
        Toast({position: 'top',message: 'Registered Successful'})
        this.$router.push('/login')
      }else{
        Toast({position:'top',message:'Registered failure'})
      }
    },
    async sendCode(){//发送验证码
      console.log(this.form.email);
      if (this.$route.params.id*1 == 2) {//注册
        const response = await reqLoginEmail({email:this.form.email})
        if (response.code*1==3) {
          Toast({position:'top',message:'Sent successfully'})
          this.countdown = 90
          this.disabled = true
          this.time()
        }else if(response.code*1==1){
          Toast({position:'top',message:'Email Registered'})
        }else{
          Toast({position:'top',message:'Sent failure'})
        }
      }else{//修改信息
        const response = await reqRetrieveCode({email:this.form.email})
        if (response.code*1==3) {
          Toast({position:'top',message:'Sent successfully'})
          this.countdown = 90
          this.disabled = true
          this.time()
        }else if(response.code*1==1){
          Toast({position:'top',message:'Not registered yet'})
        }else{
          Toast({position:'top',message:'Sent failure'})
        }
      }
      
    },
    time(){//倒计时
      this.timer = setInterval(()=>{
        this.countdown--
        if (this.countdown<=0) {
          clearInterval(this.timer)
          this.countdown = "verification code"
          this.disabled = false
        }
      },1000)
    },
  }
}
</script>

<style scoped>
  .registered{
    position: relative;
    height: 100%;
    width: 100%;
    z-index: 1;
    background-color: white;
    background-image: url('https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/login/login_bg.png');
    background-size: 100% 100%;
  }
  .mint-header{
    position: relative;
    z-index: 10;
    height: 40px;
    background-color: #008baf;
  }
  .login_content{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    height: 100%;
  }
  .login_img{
    max-width: 140px;
    margin: auto;
    padding: 40px 0 10px;
  }
  .email_login{
    padding: 20px 40px;
  }
  .registered .input_Code{
    width: calc(100% - 130px);
    margin-right: 18px;
    vertical-align: top;
  }
  .btn_Code{
    width: 112px;
    padding-right: 0;
    padding-left: 0;
  }
  .login_icon{
    position: absolute;
    left: -46px;
    top: 4px;
    width: 32px;
    height: 32px;
    margin-top: 4px;
  }
  .email_login p{
    font-size: 12px;
    color: #b8b8b8;
    text-align: end;
  }
  .retrieve_password{
    margin-top: -5px;
  }

  .email_login .new_email{
    text-align: center;
  }
  .new_email span{
    color: #fae655;
  }
  #app .login >>> .el-input.is-active .el-input__inner,#app .login >>> .el-input__inner:focus{
    border-color: #fae655;
  }
  .email_login>>>.el-select{
    display: block;
  }
  .agreement{
    color: #d6c751;
  }
  .login_button{
    padding-top: 20px;
    margin-left: -50px;
  }
  .login_button button{
    width: 100%;
    border-radius: 20px;
    background-image: linear-gradient(#fffa81,#f2c409);
    border: none;
    color: white;
    font-weight: 600;
  }
  .login_button button:focus{
    color: white;
  }
</style>
<style>
  .inoput_underline input{
    background-color: transparent !important;
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #aaa;
    padding: 0 6px;
    color: white;
  }
  .inoput_underline input:focus,
  .inoput_underline input:hover{
    border-color: #aaa;
  }
  
</style>